import Vue from "vue";

Vue.filter('number', function (value, fractionDigits = 0) {
  if (isNaN(parseFloat(value))) {
    return value;
  }
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: fractionDigits
  });
  return formatter.format(value);
});

Vue.filter('uppercase', function (value, fractionDigits = 0) {
  if (isNaN(parseFloat(value))) {
    return value;
  }
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: fractionDigits
  });
  return formatter.format(value);
});

Vue.filter('formattedPin', function (pin, isFullPinFormat = false) {
  if (isNaN(parseFloat(pin))) {
    return pin
  }

  let formattedPin = pin.split('').reduce( (prevVal, currentVal,index) =>{
    if (index === 1 || index === 3 || index === 6 || index === 9) {
      currentVal = currentVal + '-'
    }
    return prevVal = prevVal + currentVal
  });

  if (isFullPinFormat && pin.length <= 10) {
    formattedPin = formattedPin + '-0000'
  }

  return formattedPin;
});

Vue.filter('formattedPhone', function (phone) {
  if (!phone || phone.length === 0) {
    return phone
  }

  let formattedPhone = phone.split('').reduce( (prevVal, currentVal,index) =>{
    if (index === 2 || index === 5) {
      currentVal = currentVal + '-'
    }
    return prevVal = prevVal + currentVal
  });

  return formattedPhone;
});